import React, { useState, useEffect } from 'react';

import {
  getProducts,
  postProduct,
  editProduct,
  deleteProduct,
} from '../../../api/services/productsApi';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminProductCard from '../../../components/admin/cards/AdminProductCard/AdminProductCard';
import ProductModal from '../../../components/admin/modals/ProductModal/ProductModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminProducts.css';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  //Product Admin Page
  const getAllProducts = async () => {
    try {
      const allProducts = await getProducts();
      setProducts(allProducts);
    } catch (err) {
      console.error('Failed to fetch products:', err);
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  const onAddClickHandler = () => {
    setSelectedProduct({});
    setEditModalMode('add');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (product) => {
    setSelectedProduct(product);
    setEditModalMode('edit');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (product) => {
    setSelectedProduct(product);
    setIsDeleteModalOpen(true);

    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedProduct(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedProduct(null);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editModalMode === 'edit') {
        await editProduct(selectedProduct._id, formData);
        alert('Success! Product updated successfully!');
      } else {
        await postProduct(formData);
        alert('Success! Product created successfully!');
      }

      await getAllProducts();
      onModalClose();
    } catch (error) {
      console.error('Submit failed:', error);
      alert('Something went wrong.');
    }
  };

  const onConfirmDelete = async () => {
    try {
      await deleteProduct(selectedProduct._id);
      await getAllProducts();
      onDeleteModalClose();

      alert(`Deleted! ${selectedProduct.name} deleted successfully!`);
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete product.');
    }
  };

  return (
    <div className='admin__product__page'>
      <div className='admin-product-container'>
        <div className='admin-products-title-add-container'>
          <h1 id='admin-products-title'>Products</h1>
          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={onAddClickHandler}
          >
            Add Product
          </ContentChangeButton>
        </div>
        <div className='product__layout'>
          {products.map((p) => (
            <AdminProductCard
              key={p._id}
              product={p}
              onEditClickHandler={onEditClickHandler}
              onDeleteClickHandler={onDeleteClickHandler}
            />
          ))}
        </div>
      </div>

      {isEditModalOpen && (
        <ProductModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          product={selectedProduct}
          mode={editModalMode}
        />
      )}

      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle={selectedProduct?.name}
        />
      )}
    </div>
  );
};

export default AdminProducts;
